import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { Ghost } from "lucide-react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/app", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#050505] flex items-center justify-center px-6">
      <img
        src="https://images.unsplash.com/photo-1693648793394-0b76b7eb042e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZXh0dXJlJTIwbHV4dXJ5fGVufDB8fHx8MTc4MjE3NDI0NHww&ixlib=rb-4.1.0&q=85"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-30 mix-blend-overlay pointer-events-none"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#050505]/40 to-[#050505]" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 w-full max-w-md text-center"
      >
        <div className="flex items-center justify-center mb-8">
          <div className="h-16 w-16 rounded-2xl border border-white/10 bg-[#121212] flex items-center justify-center ghost-glow">
            <Ghost className="h-8 w-8 text-[#A3B8CC]" strokeWidth={1.5} />
          </div>
        </div>

        <h1 className="font-display text-6xl font-semibold tracking-tight mb-3">Wado</h1>
        <p className="text-[#8A8A8A] text-lg leading-relaxed mb-2">
          Messagerie privée. Éphémère.
        </p>
        <p className="text-[#8A8A8A] text-base leading-relaxed mb-12">
          Lisez en toute discrétion grâce au <span className="text-[#A3B8CC]">mode fantôme</span>.
        </p>

        <button
          data-testid="login-google-button"
          onClick={handleLogin}
          className="w-full bg-white text-black font-medium px-8 py-4 rounded-full hover:bg-gray-200 transition-colors flex items-center justify-center gap-3 hover:-translate-y-[1px] hover:shadow-lg duration-300"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          Continuer avec Google
        </button>

        <p className="text-[#8A8A8A]/60 text-xs tracking-[0.2em] uppercase font-bold mt-10">
          Vos conversations restent les vôtres
        </p>
      </motion.div>
    </div>
  );
}
